import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import CashoutCreate from "../../components/Transaction/CashoutCreate";

const CashoutCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <CashoutCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default CashoutCreatePage;